import React from 'react';

import FieldText from '../commons/FieldText';
import FieldNumber from '../commons/FieldNumber';

const RepresentativePersonData = () => {
  return (
    <div>
      <h3>Respresentante Legal</h3>
      <hr className="solid" />
      <div className="field-row">
        <FieldText
          label="Nombre del representate legal"
          name="representativeName"
          required />
        <FieldText
          label="Apellido paterno del representate legal"
          name="representativeFirstLastname"
          required />
      </div>
      <div className="field-row">
        <FieldText
          label="Apellido materno del representate legal"
          required
          name="representativeSecondLastname" />
        <FieldText
          label="Email"
          required
          name="representativeEmail" />
      </div>
      <div className="field-row">
        <FieldNumber
          className="field -half-input"
          maxLength={10}
          label="Teléfono celular"
          required
          placeholder="000 0000 000"
          name="representativeCellphone" />
      </div>
    </div>
  );
};

export default RepresentativePersonData;
